import React, { FC, Dispatch, SetStateAction, useState } from 'react';
import { AiFillLock } from 'react-icons/ai';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';

import TcpaSection from '@core/shared/features/TcpaSection';

import ConfirmationRevamp from '../ConfirmationRevamp';
import styles from './PreSubmissionPageRevamp.module.css';

type NoPiiVariantConfirmationProps = {
  isHeclidReady: boolean;
  isSubmitting: boolean;
  buttonText: React.ReactNode;
  piiLeadErrors: { field: string }[];
  setFirstName: Dispatch<SetStateAction<string>>;
  setLastName: Dispatch<SetStateAction<string>>;
  setEmail: Dispatch<SetStateAction<string>>;
  setPhone: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
  tcpa: any;
  privacyNoteLockClassName?: string;
};

const NoPiiVariantConfirmation: FC<NoPiiVariantConfirmationProps> = ({
  isHeclidReady,
  isSubmitting,
  buttonText,
  piiLeadErrors,
  setFirstName,
  setLastName,
  setEmail,
  setPhone,
  handleSubmit,
  tcpa,
  privacyNoteLockClassName,
}) => {
  const [isWhyWeAskOpen, setIsWhyWeAskOpen] = useState(true);

  const drawerBenefitsList = [
    'Connect with a school advisor.',
    'Get tuition, deadline, and requirement details.',
    'Learn how this program fits your career goals.',
  ];

  const whyWeAskContentText =
    'Your phone number allows a school advisor to contact you with details about this program, financial aid, and your application process.';
  return (
    <aside className={styles.variantFormColumn}>
      <div className={styles.variantFormHeader}>
        <h3 className={styles.variantFormTitle}>
          Find Out if This Program is
          <br />
          Right For You
        </h3>
        <ul className={styles.variantFormBenefits}>
          {drawerBenefitsList.map((benefit, index) => (
            <li key={`variant-benefit-${index}`}>{benefit}</li>
          ))}
        </ul>
      </div>

      <div className={styles.variantFormFields}>
        <ConfirmationRevamp
          setFirstName={setFirstName}
          setLastName={setLastName}
          setEmail={setEmail}
          setPhone={setPhone}
          piiLeadErrors={piiLeadErrors}
        />
      </div>

      <div className={styles.variantTermsSection}>
        <div className={styles.variantPrivacyNote}>
          <AiFillLock className={privacyNoteLockClassName ?? styles.variantLockIcon} /> We never share your info without
          consent.
        </div>
        <TcpaSection tcpa={tcpa ? [tcpa] : null} />
      </div>
      <button
        className={styles.variantCtaButton}
        type="submit"
        data-tf-element-role="submit"
        disabled={!isHeclidReady || isSubmitting}
        onClick={handleSubmit}
      >
        {buttonText}
      </button>
      <div className={styles.variantCollapsible}>
        <button
          type="button"
          className={styles.variantWhyWeAskTrigger}
          onClick={() => setIsWhyWeAskOpen(!isWhyWeAskOpen)}
        >
          <span>Why we ask for your information</span>
          {isWhyWeAskOpen ? <HiChevronUp /> : <HiChevronDown />}
        </button>
        {isWhyWeAskOpen && (
          <div className={styles.variantWhyWeAskContent}>
            <p>{whyWeAskContentText}</p>
          </div>
        )}
      </div>
    </aside>
  );
};

export default NoPiiVariantConfirmation;
